module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  flipVertical: function (element) {
    this.canvas.selectOnly([element]);
    this.canvas.setFlip('v');
    this.trigger('flip_vertical');
  },

  flipHorizontal: function (element) {
    this.canvas.selectOnly([element]);
    this.canvas.setFlip('h');
    this.trigger('flip_horizontal');
  },

  explode: function (element) {
    if (!(element.tagName === 'g' && $(element).hasClass('sticker') && element.childNodes.length > 1)) {
      return;
    }

    const parent = element.parentNode;
    const anchor = element.nextSibling;

    if ($(element).find('.textarea, .layoutBox').length > 0) {
      this._explodeSubelement(element, parent, anchor);
    } else {
      this._explode(element, parent, anchor);
    }

    this.canvas.clearSelection();
    this.trigger('explode');
  },

  _explodeSubelement: function (g, parent, anchor) {
    _.each($(g).find('.textarea, .layoutBox'), function (el) {
      el = parent.insertBefore(el, anchor);
      this._updateClasses(el);

      if ($(el).hasClass('layoutBox')) {
        let defs = $('#svgcontent>defs').get(0);

        if (!defs) {
          const svgcontent = $('#svgcontent').get(0);
          defs = window.document.createElementNS(svgedit.NS.SVG, 'defs');
          svgcontent.insertBefore(defs, svgcontent.firstChild);
        }

        $(g).find('defs clippath').each(function (i, clippath) {
          const oldDef = clippath.parentNode;
          defs.insertBefore(clippath, defs.firstChild);
          g.removeChild(oldDef);
        });
      }
    }, this);

    this.canvas.clearSelection();
  },

  _explode: function (g, parent, anchor) {
    while (g.firstChild) {
      let elem = g.firstChild;

      if ($(elem).is('rect.background')) {
        elem.parentNode.removeChild(elem);
        continue;
      }

      for (let j = 0; j < elem.childNodes.length; j++) {
        const node = elem.childNodes[j];

        if (node.tagName !== 'g' && node.tagName !== 'rect') {
          const parentNode = node.parentNode;
          const siblingNode = node.nextSibling;

          siblingNode && parentNode.insertBefore(node, siblingNode);
          siblingNode || parentNode.appendChild(node);
        }
      }

      if (!elem.childNodes.length && elem.tagName !== 'g') {
        const newG = document.createElementNS(svgedit.NS.SVG, 'g');
        newG.appendChild(elem);
        elem = newG;
      }

      elem = parent.insertBefore(elem, anchor);
      this._updateClasses(elem);
    }
  },

  _updateClasses: function (elem) {
    const elementType = $(elem).find('text').length
      ? 'textarea'
      : $(elem).is('image[clip-path]')
        ? 'layoutBox'
        : 'sticker';

    svgedit.utilities.assignAttributes(elem, { class: 'element ' + elementType });
    svgedit.utilities.assignAttributes(elem, { id: this.canvas.getNextId() });
  }
}, Backbone.Events);
